import { Col, Row } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

interface FormFieldEditorHeaderProps {
    visibleDescriptionLabel: string;
    fieldTypeLabel?: string;
    placeholderLabel: string;
}

export const FormFieldEditorHeader = ({
    visibleDescriptionLabel,
    fieldTypeLabel,
    placeholderLabel,
}: FormFieldEditorHeaderProps) => {
    const { t } = usePaldockTranslation("forms.general-fields");

    return (
        <div className="mb-2 pl-10 pr-4 text-sm font-semibold">
            <Row gutter={10}>
                <Col span={6}>{t("system_name.label")}</Col>
                <Col span={6}>{visibleDescriptionLabel}</Col>
                <Col span={5}>{fieldTypeLabel ?? t("type.label")}</Col>
                <Col span={5}>{placeholderLabel}</Col>
                <Col span={2} />
            </Row>
        </div>
    );
};
